
//***********************************************************
//
// MANAGEMENT OF THE NEKUDOT
//
//***********************************************************

// const nekudotTest = ["לֹא","לִקְנוֹת","עַל-יַד","עַתִּיק","דִּירָה","בִּנְיָן","לִהְיוֹת שָׁוֶה","דַּיֶּלֶת","אִידֵיאָלִי","טֵלֶוִיזְיָה","מְצוּיָן","הַבַּיְתָה","חֲנוּת"]

// Remove nekudot and add some letters when needed
// When the letter are added : we mark them with a |
// If a youd is not added because the hiriq is on the first letter we put a @ instead
function removeNekudotAddMarks(vocalized) {
    const isNekuda = (char) => {
        const cp = char.codePointAt(0);
        return cp >= 0x0591 && cp <= 0x05C7;
    };

    // First : Replace the hyphens with a space and the daguesh (sauf dans vav)
    vocalized = vocalized.replace(/\u05BE/g, ' ').replace(/\u002D/g, ' ').replace(/(?<!\u05D5)\u05BC/g, '')

    const chars = [...vocalized.normalize('NFD')];
    let result = '';
    let i = 0;

    while (i < chars.length) {
        const curr = chars[i];
        const next = chars[i + 1] || '';
        const nextCode = next.codePointAt(0);

        // Handle שׁוּרוק (shuruk) = וּ
        const isShuruk = curr === 'ו' && nextCode === 0x05BC;
        if (isShuruk) {
            result += 'ו';
            i += 2;
            continue;
        }

        if (curr === 'ו') {
            // Regarder les diacritiques qui suivent immédiatement
            let diacritics = [];
            let j = i + 1;
            while (j < chars.length && isNekuda(chars[j])) {
                diacritics.push(chars[j].codePointAt(0));
                j++;
            }

            const hasHolam = diacritics.includes(0x05B9);
            const hasDagesh = diacritics.includes(0x05BC);

            // Ne pas doubler si début de mot (conjonction וְ ou préposition) ou fin de mot
            const isStart = result.length === 0 || /\s/.test(result.slice(-1));
            const isEnd = j === chars.length

            if (!hasHolam && !hasDagesh && !isStart && !isEnd) {
                result += 'וו';
                i = j;
                continue;
            }
        }

        const isRealWordStart = (index) => {
            // Cherche la dernière vraie lettre non diacritique avant index
            let last = -1;
            for (let k = index - 1; k >= 0; k--) {
                if (!isNekuda(chars[k])) {
                    last = k;
                    break;
                }
            }

            if (last === -1) return true; // tout au début

            const letter = chars[last];

            if (letter === ' ' || letter === '\u05BE' || letter === '-') return true;

            // Est-ce une préposition mono-lettre ?
            const prepositions = ['ב', 'כ', 'ל', 'מ', 'ו', 'ה'];
            return prepositions.includes(letter);
        };

        // Handle חִירִיק (ḥirik) = ִ
        if (nextCode === 0x05B4) {
            result += curr;
            if (curr === "י") result += "@"
            i += 2;

             // Cherche prochaine lettre réelle (non diacritique)
            let j = i;
            while (j < chars.length && isNekuda(chars[j])) j++;

            if (curr !== 'י' && isRealWordStart(i-2) && chars[j] !== 'י') result += "@"

            if (
                curr !== 'י' &&
                !isRealWordStart(i - 2) // ← attention, on doit regarder la lettre ayant porté le hiriq
            ) {
                // Cherche prochaine lettre réelle (non diacritique)
                let j = i;
                while (j < chars.length && isNekuda(chars[j])) j++;

                const nextReal = chars[j];

                // Exception : ne pas ajouter י après לִ (infinitif)
                const isInfinitiveLi = curr === 'ל' && nextReal && /[\u05D0-\u05EA]/.test(nextReal);

                if (!isInfinitiveLi && nextReal !== 'י') {
                    result += '|י'; // We put the | to mark a letter that was added
                }
            }
            continue;
        }

        // Handle חוֹלָם (ḥolam) = ֹ
        if (nextCode === 0x05B9) {
            result += curr;
            if (curr === "י") result += "@"
            i += 2;

            if (curr !== 'ו') {
                let j = i;
                while (j < chars.length && isNekuda(chars[j])) j++;
                if (chars[j] !== 'ו') result += '|ו'; // We put the | to mark a letter that was added
            }
            continue;
        }

        // Handle קֻבּוּץ (qubuts) = ֻ
        if (nextCode === 0x05BB) {
            result += curr;
            if (curr === "י") result += "@"
            i += 2;

            if (curr !== 'ו') {
                let j = i;
                while (j < chars.length && isNekuda(chars[j])) j++;
                if (chars[j] !== 'ו') result += 'ו';
            }
            continue;
        }

        // SI youd en début de mot ou après préposition on double pas
        let doubleyoud = true
        if (curr === 'י') {
            const prepositions = ['ב', 'כ', 'ל', 'מ', 'ו', 'ה'];
            if (result.length === 0 || (prepositions.includes(result[result.length-1]) && (result.length ===1 || result[result.length-2]===" ")))
                doubleyoud = false;
        }

        // Si י est suivi d'une voyelle qui n'est pas חִירִיק ou un shva
        // et que la lettre suivante (réelle) n'est pas un ו avec חוֹלָם ou שׁוּרוּק,
        // alors on double le י
        // ET  on double pas en début de mot ou juste après une préposition (genre ve)
        if (
            curr === 'י' &&
            doubleyoud &&
            isNekuda(next) &&
            next.codePointAt(0) !== 0x05B4 && // ִ hiriq
            next.codePointAt(0) !== 0x05B0 && // ִ shva
            result.length > 0 && !/\s/.test(result.slice(-1)) // pas début de mot
        ) {
            // Cherche la lettre réelle suivante
            let j = i + 2;
            while (j < chars.length && isNekuda(chars[j])) j++;

            // Est-ce que le י est suivi d’un ה ? (forme "יה")
            let k = i + 1;
            while (k < chars.length && isNekuda(chars[k])) k++;
            const isYahEnding = chars[k] === 'ה';

            // Test י ו ת à la fin du mot
            let isYoudVavTavEnding = false;
            if (!isYahEnding && chars[k] === "ו") { // Vérifier hiriq !!!
                k+=1;
                while (k < chars.length && isNekuda(chars[k])) k++;
                isYoudVavTavEnding = chars[k] === "ת"
            }

            if (!isYahEnding && !isYoudVavTavEnding) {
                // ✅ Ajoute יי
                result += 'י|י';

                // Passe au caractère suivant non-diacritique
                i++;
                while (i < chars.length && isNekuda(chars[i])) i++;
                continue;
            }
        }

        // Autres diacritiques : on saute
        if (isNekuda(curr)) {
            i++;
            continue;
        }

        // Lettre normale
        result += curr;
        if (curr === "י") result += "@"
        i++;
    }

    return result;
}

// nekudotTest.forEach(w => console.log("NEKUDOT",w,"=>",removeNekudotAddMarks(w)));

function removeNekudot(vocalized) {
    return removeNekudotAddMarks(vocalized).replace(/\|/g, '').replace(/@/g, '')
}

// Liste des substitutions phonétiques possibles
// [Lettre origine, substitution, lettre qui doit être présente dans le mot initial , lettre qui ne doit pas être présente dans mot initial]
const phoneticSubstitutions = [
  [/ו{2,}/g, 'ו'],         // Double vav → vav simple
  [/י{2,}/g, 'י'],         // Double youd → youd simple
  [/א/g, 'ע'],             // Aleph → Ayin (et vice versa plus bas)
  [/ע/g, 'א'],             // Ayin → Aleph
  [/ט/g, 'ת'],             // Tet → Tav
  [/ת/g, 'ט'],             // Tav → Tet
  [/כ/g, 'ק','כּ'],
  [/ק/g, 'כ'],
  [/ח/g, 'כ'],
  [/כ/g, 'ח', null, 'כּ'],
  [/ס/g, 'ש'],
  [/ש/g, 'ס', 'שׂ'],
  [/\|./g, ''],  // The marked letters
  [/@/g, 'י'],  // Adding a youd
];

// Génère des variantes simplifiées d’un mot donné
// The vocalized word might have some marks |
// When there is  a mark : a variant is to forget the letter right after the mark
function generateVariants(vocalizedWord, word) {
  const variants = new Set();
  variants.add(word);

  // On génère récursivement les variantes avec substitutions
  const queue = [word];
  while (queue.length > 0) {
    const current = queue.pop();
    phoneticSubstitutions.forEach(([regex, replacement, must=null, mustnot: null]) => {
        if (!((must && !vocalizedWord.includes(must)) || (mustnot && vocalizedWord.includes(mustnot)))) {
            const newVariant = current.replace(regex, replacement);
            if (!variants.has(newVariant)) {
                variants.add(newVariant);
                queue.push(newVariant);
            }
        }
    });
  }

  console.log("COMP1",word,[...variants])

  return new Set([...variants].map(v => v.replace(/\|/g, '').replace(/@/g, '')));
}

// Compare un mot brut (dictée vocale) à un mot en écriture pleine
function isSameHebrewWord(referenceVocalizedWord, spokenWord) {
    const referenceWord = removeNekudotAddMarks(referenceVocalizedWord);
    const variants = generateVariants(referenceVocalizedWord,referenceWord);
    return variants.has(spokenWord);
}

function normalizeString(input) {
    return input
        // Supprimer le texte entre crochets, y compris les crochets
        .replace(/\[.*?\]/g, '').replace(/\u05BE/g, ' ').replace(/\u002D/g, ' ') // supprime les tirets
        // Supprimer toutes les ponctuations
        .replace(/[.,/#!$%^&*;:{}=\-_`~()?"'«»]/g, '')
        // Supprimer les espaces en trop (optionnel pour faire propre)
        .replace(/\s{2,}/g, ' ')
        .normalize('NFC')
        .replace(/[\u200F\u200E\u202A-\u202E\u200B\uFEFF]/g, '') // Supprime les caractères invisibles : RTL, LTR, espaces zéro-width, etc.
        .trim().normalize();
}

function checkUnvocalizedInput(trueVocalizedPhrase, unvocalizedPhrase) {
    const expected = normalizeString(trueVocalizedPhrase).trim().split(/\s+/);
    const actual = normalizeString(unvocalizedPhrase).trim().split(/\s+/);

    let success = true;

  const result = [];
    let ei = 0; // index in expected
    const matched = new Set(); // indices d'actual déjà utilisés

    for (let ai = 0; ai < actual.length; ai++) {
        const word = actual[ai];
        let found = false;

        for (let k = ei; k < expected.length; k++) {
            if (isSameHebrewWord(expected[k],word)) {
                while (ei < k) {
                    result.push(["???", false]);
                    success = false;
                    ei++;
                }
                result.push([word, true]);
                matched.add(ai);
                ei++;
                found = true;
                break;
            }
        }

        if (!found) {
            result.push([word, false]);
            success = false;
            matched.add(ai);
        }
    }

    while (ei < expected.length) {
        result.push(["???", false]);
        success = false;
        ei++;
    }

    // We take out the spurious ???

    let result1 = [];

    // If one word is wrong then we don't need the ???
    if (result.some(v => v[0]!=='???' && v[1]===false)) {
        result1 = result.filter(v => v[0]!=='???');
    }
    // Otherwise we take out successive ???
    else {
        let count = 0;

        for (const item of result) {
            if (item[0] === '???') {
                if (count < 1) {
                    result1.push(item);
                    count++;
                }
                // sinon : ignorer (trop d'affilée)
            } else {
                result1.push(item);
                count = 0; // on reset la séquence
            }
        }
    }

    return [success,result1];
}

// Renvoie une version où tous les diacritiques hébreux sont supprimés
// SAUF le dagueš (U+05BC) juste après ב/כ/ך/פ/ף.
function stripHebrewDiacriticsKeepBKPDagesh(s) {
  const KEEP_DAGESH_AFTER = new Set(['\u05D1', '\u05DB', '\u05DA', '\u05E4', '\u05E3']); // ב כ ך פ ף
  const isHebrewDiacritic = (ch) => /\p{Script=Hebrew}/u.test(ch) && /[\u0591-\u05C7]/u.test(ch);

  s = s.normalize('NFC');
  let out = '';
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (!isHebrewDiacritic(ch)) {
      out += ch;
      continue;
    }
    // c'est un diacritique
    if (ch === '\u05BC') { // dagueš
      const prev = out[out.length - 1]; // dernière lettre déjà gardée
      if (KEEP_DAGESH_AFTER.has(prev)) {
        out += ch;        // on ne garde le dagueš que après ב/כ/ך/פ/ף
      }
      // sinon on le jette
    }
    // tous les autres diacritiques sont jetés
  }
  return out;
}

function isHebrewLetter(ch) {
  const cp = ch.codePointAt(0);
  return cp >= 0x05D0 && cp <= 0x05EA; // א..ת (inclut déjà les finales)
}

// Tokenise en unités "lettre" ou "lettre+dagueš" (on ne conserve un dagueš
// que s’il suit immédiatement la lettre, conformément au strip ci-dessus).
function tokenizeHebrewWithBKPDagesh(s) {
  const tokens = [];
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];

    // 1. Lettre hébraïque
    if (isHebrewLetter(ch)) {
      let tok = ch;
      if (s[i + 1] === '\u05BC') { // dagueš
        tok += '\u05BC';
        i++;
      }
      tokens.push(tok);
    }

    // 2. Autoriser espace, tiret ASCII, et maqaf hébreu
    else if (ch === ' ' || ch === '-' || ch === '\u05BE') {
      tokens.push(ch);
    }

    // 3. Tout autre caractère = invalide
    else {
      return { tokens: [], ok: false };
    }
  }
  return { tokens, ok: true };
}


/**
 * Vérifie que `word` (hébreu possiblement avec niqqud) n’utilise que des lettres
 * présentes dans `allowed`, en ignorant tous les niqqud/ta’amim/etc.,
 * mais en distinguant uniquement les dagueš de ב/כ/ך/פ/ף.
 *
 * Exemple : "בּ" ≠ "ב", "פּ" ≠ "פ", "כּ" ≠ "כ".
 */
function hebrewComposedOnlyOf_BKPDagesh(word, allowed) {
  const w = stripHebrewDiacriticsKeepBKPDagesh(word);
  const a = stripHebrewDiacriticsKeepBKPDagesh(allowed);

  const { tokens: aTok, ok: aOk } = tokenizeHebrewWithBKPDagesh(a);
  if (!aOk) return false;
  const allow = new Set(aTok);

  const { tokens: wTok, ok: wOk } = tokenizeHebrewWithBKPDagesh(w);
  if (!wOk) return false;

  return wTok.every(t => allow.has(t));
}


export {
    checkUnvocalizedInput,
    removeNekudot,
    hebrewComposedOnlyOf_BKPDagesh
}